import _ from "lodash";
import { useEffect, useState } from "react";
import BarChart from "../BarChart";
import Grid from "../Grid";

import { useTranslation } from "react-i18next";
import styles from "./styles.module.scss";

function MultiBarChart({
  graphData,
  subData = "subject_details",
  id = "subject_id",
  title,
  theme,
  ...props
}) {
  const { t } = useTranslation();
  //  const [data, setData] = useState(graphData);
  const [subjectData, setSubjectData] = useState([]);
  const [maxValue, setMaxValue] = useState(0);

  useEffect(() => {
    if (!_.isEmpty(graphData)) {
      const updatedData = [];
      const values = [];
      [...graphData[subData]].map(item => {
        let obj = item;
        let regionData = graphData.region_details[0][item[id]];
        regionData = regionData.map(newItem => {
          values.push(newItem.average);
          return {
            name: newItem.title,
            primary: newItem.average ? newItem.average : 0,
          };
        });
        obj = { ...item, regionData };
        updatedData.push(obj);
      });

      setSubjectData(updatedData);
      setMaxValue(Math.max(...values));
    } else {
      setSubjectData([]);
      setMaxValue(0);
    }
  }, [graphData]);

  return (
    <>
      <h4 className={`${styles.sectionSubHead}`}>{title}</h4>
      <Grid>
        {subjectData &&
          subjectData.map((list, index) => (
            <div key={index}>
              <p className={styles.sectionInfoText}>
                {list.subject} - {list.sub_subject}
              </p>
              <BarChart
                size="small"
                colors={[theme]}
                averageColors={["#BCC5D6"]}
                fontColors={["#212121"]}
                maxValue={maxValue}
                average={{
                  name: "Average",
                  value: list.average ? list.average : 0,
                }}
                data={list.regionData}
                countryIcon={true}
                debug
              />
            </div>
          ))}
        {graphData.length === 0 && (
          <div className={styles.noData}>{t("dashboard.noDataYet")}</div>
        )}
      </Grid>
    </>
  );
}

export default MultiBarChart;
